(function () {
  // Approx PHP -> USD reference rate. Update periodically (e.g. from BSP/xe.com).
  // Last set: July 2026, ~61.5 PHP per 1 USD.
  var RATE_PHP_PER_USD = 61.5;
  var CACHE_KEY = 'pd_geo_country';
  var CACHE_TTL = 24 * 60 * 60 * 1000; // 24h

  function formatUsd(php) {
    var usd = php / RATE_PHP_PER_USD;
    return '$' + usd.toFixed(2);
  }

  function formatPhpNote(php) {
    var amt = php.toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '≈ ₱' + amt + ' · billed in PHP';
  }

  var state = { ready: false, foreign: false };

  function applyStatic() {
    if (!state.foreign) return;

    // Reveal any generic "foreign visitor only" disclaimer notes.
    var notes = document.querySelectorAll('.pd-foreign-note[hidden]');
    for (var n = 0; n < notes.length; n++) notes[n].hidden = false;

    // Convert every price element carrying a data-php amount (in PHP, not cents).
    var els = document.querySelectorAll('[data-php]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.pdConverted) continue;
      var php = parseFloat(el.getAttribute('data-php'));
      if (isNaN(php) || php <= 0) continue;
      el.dataset.pdConverted = '1';
      if (el.classList.contains('pd-usd-est')) {
        // Secondary note element: shows the real PHP amount that will be billed.
        el.textContent = formatPhpNote(php);
        el.hidden = false;
      } else {
        // Primary price element: swap to the USD estimate. If this price is on sale
        // (data-compare-php present), rebuild as "sale price + struck-through original"
        // instead of overwriting textContent, so the original price survives conversion.
        var comparePhpAttr = el.getAttribute('data-compare-php');
        var comparePhp = comparePhpAttr ? parseFloat(comparePhpAttr) : NaN;
        if (!isNaN(comparePhp) && comparePhp > php) {
          el.textContent = '';
          el.appendChild(document.createTextNode(formatUsd(php)));
          var wasSpan = document.createElement('span');
          wasSpan.className = 'was';
          wasSpan.textContent = formatUsd(comparePhp);
          el.appendChild(wasSpan);
        } else {
          el.textContent = formatUsd(php);
        }
      }
    }
  }

  function setForeign(isForeign) {
    state.foreign = isForeign;
    state.ready = true;
    applyStatic();
    document.dispatchEvent(new CustomEvent('pd:currency-ready', { detail: state }));
  }

  window.PDCurrency = {
    isForeign: function () { return state.foreign; },
    isReady: function () { return state.ready; },
    formatUsd: formatUsd,
    formatPhpNote: formatPhpNote,
    rate: RATE_PHP_PER_USD,
    onReady: function (cb) {
      if (state.ready) { cb(state); }
      else { document.addEventListener('pd:currency-ready', function () { cb(state); }, { once: true }); }
    },
    // Re-scan the page for any [data-php] elements added after the initial pass
    // (e.g. product cards appended by an infinite-scroll / "load more" script).
    // Safe to call anytime — already-converted elements are skipped via data-pd-converted.
    refresh: applyStatic
  };

  document.addEventListener('shopify:section:load', applyStatic);

  function withCache() {
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && cached.country && (Date.now() - cached.ts) < CACHE_TTL) {
        setForeign(cached.country !== 'PH');
        return true;
      }
    } catch (e) {}
    return false;
  }

  if (withCache()) return;

  fetch('https://ipapi.co/country/')
    .then(function (r) { return r.ok ? r.text() : null; })
    .then(function (code) {
      if (!code) { setForeign(false); return; }
      code = code.trim();
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ country: code, ts: Date.now() }));
      } catch (e) {}
      setForeign(code !== 'PH');
    })
    .catch(function () { setForeign(false); });
})();
